/**
 * Items to tick off one by one — ingredients, steps. A ticked item stays where
 * it is, dimmed and struck through, so the list never jumps under a finger.
 * The whole row is the checkbox's label, so a tap on the text toggles it. The
 * screen owns the ticks.
 */
export function Checklist({
  items,
  checked,
  onToggle,
  numbered = false,
}: {
  items: readonly string[];
  /** One flag per item, by index. */
  checked: readonly boolean[];
  onToggle: (index: number) => void;
  /** Prefix each item with its position from 1, as steps are. */
  numbered?: boolean;
}) {
  const List = numbered ? 'ol' : 'ul';
  return (
    <List className="checklist">
      {items.map((item, i) => {
        const on = checked[i] ?? false;
        return (
          // Items may repeat ("sól" twice), and the order never changes here.
          <li key={i}>
            <label
              className={on ? 'checklist-item is-active' : 'checklist-item'}
            >
              <input
                type="checkbox"
                className="checkbox-violet"
                checked={on}
                onChange={() => onToggle(i)}
              />
              {numbered && <span className="checklist-number">{i + 1}.</span>}
              <span className="checklist-text">{item}</span>
            </label>
          </li>
        );
      })}
    </List>
  );
}
